import { CandidatePersonalExperienceModel, ICandidateExperience, IEtabCategory, IQualification } from "@core/models";

const experience1 = {
  [ICandidateExperience.city]: "Paris",
  [ICandidateExperience.contract]: "cdi",
  [ICandidateExperience.endDate]: null,
  [ICandidateExperience.etabCategory]: { [IEtabCategory.id]: 39, [IEtabCategory.name]: "Hôtel *****" },
  [ICandidateExperience.etabName]: "TOTO",
  [ICandidateExperience.id]: 14,
  [ICandidateExperience.isCurrentPosition]: true,
  [ICandidateExperience.postalCode]: "75018",
  [ICandidateExperience.qualification]: { [IQualification.id]: 2, [IQualification.qualificationLabel]: "Serveur" },
  [ICandidateExperience.rating]: undefined,
  [ICandidateExperience.startDate]: "2020-01-01T00:00:00+00:00",
  [ICandidateExperience.status]: "pending",
};

const experience2 = {
  [ICandidateExperience.city]: "Paris",
  [ICandidateExperience.contract]: "cdi",
  [ICandidateExperience.endDate]: "2017-06-10T00:00:00+00:00",
  [ICandidateExperience.etabCategory]: { [IEtabCategory.id]: 39, [IEtabCategory.name]: "Hôtel *****" },
  [ICandidateExperience.etabName]: "titi",
  [ICandidateExperience.id]: 15,
  [ICandidateExperience.isCurrentPosition]: false,
  [ICandidateExperience.postalCode]: "75018",
  [ICandidateExperience.qualification]: { [IQualification.id]: 83, [IQualification.qualificationLabel]: "Agent d'entretien" },
  [ICandidateExperience.rating]: undefined,
  [ICandidateExperience.startDate]: "2016-06-11T00:00:00+00:00",
  [ICandidateExperience.status]: "unverified",
};

const experience3 = {
  [ICandidateExperience.city]: "Paris",
  [ICandidateExperience.contract]: "cdi",
  [ICandidateExperience.endDate]: "2011-09-23T00:00:00+00:00",
  [ICandidateExperience.etabCategory]: { [IEtabCategory.id]: 39, [IEtabCategory.name]: "Hôtel *****" },
  [ICandidateExperience.etabName]: "fsfsfsf",
  [ICandidateExperience.id]: 17,
  [ICandidateExperience.isCurrentPosition]: false,
  [ICandidateExperience.postalCode]: "75010",
  [ICandidateExperience.qualification]: { [IQualification.id]: 83, [IQualification.qualificationLabel]: "Agent d'entretien" },
  [ICandidateExperience.rating]: undefined,
  [ICandidateExperience.startDate]: "2010-08-19T00:00:00+00:00",
  [ICandidateExperience.status]: "unverified",
};

const experience4 = {
  [ICandidateExperience.city]: "Bordeaux",
  [ICandidateExperience.contract]: "cdi",
  [ICandidateExperience.endDate]: "2010-08-19T00:00:00+00:00",
  [ICandidateExperience.etabCategory]: { [IEtabCategory.id]: 39, [IEtabCategory.name]: "Hôtel *****" },
  [ICandidateExperience.etabName]: "tata",
  [ICandidateExperience.id]: 16,
  [ICandidateExperience.isCurrentPosition]: false,
  [ICandidateExperience.postalCode]: "75018",
  [ICandidateExperience.qualification]: { [IQualification.id]: 2, [IQualification.qualificationLabel]: "Serveur" },
  [ICandidateExperience.rating]: undefined,
  [ICandidateExperience.startDate]: "2006-05-18T00:00:00+00:00",
  [ICandidateExperience.status]: "unverified",
};

export const candidatePersonalExperiencesMocks = [experience1, experience2, experience3, experience4].map(
  (experience) => new CandidatePersonalExperienceModel(experience),
);

export const candidatePersonalExperiencesGroupsMocks = [
  {
    name: "Serveur",
    experiences: [experience1, experience4].map((experience) => new CandidatePersonalExperienceModel(experience)),
  },
  {
    name: "Agent d'entretien",
    experiences: [experience2, experience3].map((experience) => new CandidatePersonalExperienceModel(experience)),
  },
];
